"use client";

import { motion, useTransform } from "motion/react";
import type { ReactNode } from "react";

import { usePrefersReducedMotion } from "@/hooks/use-prefers-reduced-motion";

import { useFooterProgress } from "./footer-reveal";

// =============================================================================

/**
 * Content of the footer: rises and fades in while the footer is uncovered.
 */
export function FooterContent({ children }: { children: ReactNode }) {
  const progress = useFooterProgress();
  const shouldReduceMotion = usePrefersReducedMotion();
  const y = useTransform(progress, [0, 1], [-90, 0]);
  const opacity = useTransform(progress, [0.25, 0.9], [0, 1]);

  return (
    <motion.div
      data-footer-content
      className="relative flex h-full flex-col justify-end"
      style={shouldReduceMotion ? undefined : { y, opacity }}
    >
      {children}
    </motion.div>
  );
}

// =============================================================================
